import { serviceImageActionsFactory } from '../factories/serviceImageActionsFactory.ts';
import useAddMaintenanceServiceImage from './useAddMaintenanceServiceImage.ts';
import useRemoveMaintenanceServiceImage from './useRemoveMaintenanceServiceImage.ts';
import useMaintenanceServiceImages from './useMaintenanceServiceImages.ts';

export const useMaintenanceServiceImageActions = serviceImageActionsFactory({
  useAdd: useAddMaintenanceServiceImage,
  useRemove: useRemoveMaintenanceServiceImage,
  useImages: useMaintenanceServiceImages,
  queryKey: (id) => ['maintenanceServices', id],
});
